import { render, staticRenderFns } from "./NewPayment.vue?vue&type=template&id=5c25fb47&scoped=true&"
import script from "./NewPayment.vue?vue&type=script&lang=js&"
export * from "./NewPayment.vue?vue&type=script&lang=js&"
import style0 from "./NewPayment.vue?vue&type=style&index=0&id=5c25fb47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c25fb47",
  null
  
)

export default component.exports